
import React from "react";

export default function Footer() {
  return (
    <footer style={{
      background: "#eee",
      padding: "1rem",
      textAlign: "center",
      fontSize: "0.9rem",
      marginTop: "auto"
    }}>
      © {new Date().getFullYear()} MyTrailer. All rights reserved. | <a href="/privacy">Privacy Policy</a>
    </footer>
  );
}
